import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c2255f4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2255f4')) {
      api.createRecord('4c2255f4', component.options)
    } else {
      api.reload('4c2255f4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c2255f4&", function () {
      api.rerender('4c2255f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wallet_transactions/index.vue"
export default component.exports